var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2567 12.0171C24.5435 12.76 24.5435 14.6174 23.2567 15.3604L2.89536 27.116C1.60853 27.8589 -1.2388e-06 26.9302 -1.17385e-06 25.4443L-1.46139e-07 1.93311C-8.11883e-08 0.447215 1.60853 -0.481471 2.89536 0.261477L23.2567 12.0171Z",
    fill: "#F5F6F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.148a26ee.svg";
export { ForwardRef as ReactComponent };